import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { ContactpersonalOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { Contact } from '../../../classes';
import { ContactService } from '../../../services/contact.service';

@Component({
  selector: 'app-select-contact-dialog',
  templateUrl: './select-contact-dialog.component.html',
  styleUrls: ['./select-contact-dialog.component.css']
})
export class SelectContactDialogComponent implements OnDestroy, OnInit {

  contacts: ContactpersonalOverviewModel[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectContactDialogComponent>,
    private _contactService: ContactService
  ) { }

  close(){
    this._dialogRef.close();
  }

  contactClicked(contact: Contact){
    this._dialogRef.close(contact);
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.contacts.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._contactService
        .searchContactsByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialCustomers();
    this.contacts = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._contactService.searchContactsByString(search, this.page);
      })).subscribe((result: PaginationResponse<ContactpersonalOverviewModel[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<ContactpersonalOverviewModel[]>) => {
    if(this.page.pageNumber === 1) this.contacts = [];
    this.contacts.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialCustomers(){
    this._contactService.contacts$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((contacts: Contact[]) => this.contacts = contacts as any);
  }

}
